// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WlhjL","label":"styles_label__33nt9"};